import _ from "lodash";
import appointmentMapper from "@/core/services/helpers/appointmentMapper.js";

const clientMapper = {
    /**
     * Map array of client objects
     * @param {Array} clients
     * @return {Array}
     */
    mapClients: function (clients) {
        if (!Array.isArray(clients)) {
            return [];
        }

        return clients.reduce((mapped, client) => {
            try {
                mapped.push(this.mapClient(client));
            } catch (error) {
                console.error("Failed to map client", client, error);
            }
            return mapped;
        }, []);
    },

    /**
     * Map client object
     * @param {Object} client
     * @return {Object}
     */
    mapClient: function (client) {
        const firstName = client.first_name || "";
        const lastName = client.last_name || "";

        client.fullName = [firstName, lastName].filter(Boolean).join(" ");
        client.initials = (
            firstName.charAt(0) + (lastName.charAt(0) || firstName.charAt(1))
        ).toUpperCase();
        client.email = client.email || "";
        client.phone = client.phone || "";
        if (client.appointments) {
            client.appointments = appointmentMapper.mapAppointments(
                client.appointments
            );
        }
        return _.mapKeys(client, (value, key) => _.camelCase(key));
    },

    /**
     * Map array of client objects to options for select component
     * @param {Array} clients
     * @return {Array}
     */
    mapClientsAsOptions(clients) {
        let options = [];
        clients.forEach((client) => {
            let option = {};
            option.text = client.fullName;
            option.value = client.id;
            option.description = client.email;
            option.initials = client.initials;
            options.push(option);
        });
        return options;
    },
};

export default clientMapper;
